import React from "react";
import { Stack } from "@mui/material";
import PropTypes from "prop-types";
import KanbanCardQuestion from "./KanbanCardQuestion";

const KanbanCardQuestionareSection = (props) => {

    return (
        <>
            <Stack>
                {props.segments.map((segment, index) => {
                    return <KanbanCardQuestion id={index} key={index} segment={segment} />
                })}
            </Stack>
        </>
    );
};

KanbanCardQuestionareSection.propTypes = {
    segments: PropTypes.array
};

export default KanbanCardQuestionareSection;